import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { DragulaService } from 'ng2-dragula';
import { Observable } from 'rxjs';
import { CancellationService } from 'src/app/cancellation/services/cancellation.service';
import {
  PenaltyFareBasisList,
  PenaltyFareBasisMachineLearning
} from 'src/app/core/models/cancellation.model';
import { VoluntaryChangeService } from 'src/app/voluntary-change/services/voluntary-change.service';

@Component({
  selector: 'app-draggable-list-ml',
  templateUrl: './draggable-list-ml.component.html',
  styleUrls: ['./draggable-list-ml.component.scss']
})
export class DraggableListMlComponent implements OnInit, OnDestroy {
  public getLoadingPenalties$: Observable<boolean>;
  loadingPenalties: boolean = true;

  @Input() penaltyFareBasisMachineLearning: PenaltyFareBasisMachineLearning;
  @Input() groupName: string = '';
  @Output() queryNotFound = new EventEmitter();
  @Output() changeFirst = new EventEmitter<any>();
  @Input() type: number;
  @Input() managementtype: string;
  @Input() passengerTypeFareBasis: string;

  list: PenaltyFareBasisList[] = [];

  constructor(
    private dragulaService: DragulaService,
    private service: CancellationService,
    private serviceVoluntary: VoluntaryChangeService
  ) {}

  constantExangevoluntary = 'exangevoluntary';
  constantCancellation = 'cancellation';
  constantHead = 'HEAD';
  handleClassName = 'handle';

  ngOnInit() {
    if (this.managementtype === this.constantExangevoluntary) {
      this.getLoadingPenalties$ = this.serviceVoluntary.getLoadingPenalties();
    }
    if (this.managementtype === this.constantCancellation) {
      this.getLoadingPenalties$ = this.service.getLoadingPenalties();
    }
    this.groupName === '' && (this.groupName = this.constantHead);
    this.dragulaService.createGroup(this.groupName, {
      moves: (el, container, handle) => handle.className === this.handleClassName
    });
    this.loadingPenalties = false;
  }

  ngOnDestroy() {
    this.dragulaService.find(this.groupName) && this.dragulaService.destroy(this.groupName);
  }

  listChange(list: PenaltyFareBasisMachineLearning) {
    if (this.type === 1) {
      this.changeFirst.emit(list.farebasisList[0] || []);
    } else if (this.type === 2) {
      this.changeFirst.emit(list.farebasisList[0].fareBasis);
    }
  }

  findInTexts(text: string, value: string) {
    return text.includes(value);
  }

  highlight(farebasis: PenaltyFareBasisList, categoryText: string) {
    farebasis.modelRespond
      .filter((m) => m.freeText)
      .forEach((model) => {
        if (model.quote.includes('---')) {
          model.quote.split('---').forEach((quote) => {
            categoryText = categoryText.replace(
              new RegExp(this.formatQuoteBySearch(quote), 'gi'),
              (match) => '<span class="has-background-yellow"> ' + match + ' </span>'
            );
          });
        } else {
          model.quote !== '' &&
            (categoryText = categoryText.replace(
              new RegExp(this.formatQuoteBySearch(model.quote), 'gi'),
              (match) => '<span class="has-background-yellow"> ' + match + ' </span>'
            ));
        }
      });
    return categoryText;
  }

  formatQuoteBySearch(quote: string): string {
    return quote.replaceAll('-', '');
  }

  formatFreeText(freeText: string): string {
    return freeText
      .replaceAll(/\s{2,}/g, ' ')
      .replace(/(\r\n|\n|\r)/gm, ' ')
      .replaceAll('-', '')
      .replaceAll('/', '');
  }

  formatQuestion(question: string): string {
    return question.replace(/['"]+/g, '');
  }

  formatAnswer(answer: string): string {
    if (answer === 'null') return '--';
    return String(answer).toUpperCase();
  }
}
